// 2_components/login_widget.js
// Positions the login popup widget under the header login button and adds a close
// button that re-clicks the login button to dismiss it.

export function init() {
	document.addEventListener("DOMContentLoaded", function () {
		const loginWidget = document.querySelector(".popup-widget.login-widget");
		const topNavButtonLogin = document.querySelector("#header .top-nav-button-login");
		window.NAT.utils.positionOfFixedComponent(loginWidget, topNavButtonLogin, topNavButtonLogin, null, false);
		addCloseToLoginWidget();

		function addCloseToLoginWidget() {
			if (!loginWidget) return;
			if (!topNavButtonLogin) return;

			const loginWidgetCloseBtn = document.createElement("div");
			loginWidgetCloseBtn.classList.add("login-widget-close-btn");

			loginWidget.appendChild(loginWidgetCloseBtn);

			loginWidgetCloseBtn.addEventListener("click", function () {
				topNavButtonLogin.click();
			});
		}
	});
}
